import {Button, ButtonGroup} from 'platform/components';
import {Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

interface SendCombinedOnlineOfferDialogProps {
  onSendBothOffers: () => void;
  onSendSellingOffer: () => void;
}

export function SendCombinedOnlineOfferDialog(props: SendCombinedOnlineOfferDialogProps) {
  return (
    <VStack spacing={4}>
      <Text>{i18n.t('entity.sendCombinedOnlineOfferDialog.description')}</Text>
      <ButtonGroup align="right">
        <Button
          data-testid="sendCombinedOnlineOfferDialog-sendSellingOffer"
          variant="secondary"
          title={i18n.t('entity.sendCombinedOnlineOfferDialog.sendSellingOffer')}
          onClick={props.onSendSellingOffer}
        />
        <Button
          data-testid="sendCombinedOnlineOfferDialog-sendBothOffers"
          variant="primary"
          title={i18n.t('entity.sendCombinedOnlineOfferDialog.sendBothOffers')}
          onClick={props.onSendBothOffers}
        />
      </ButtonGroup>
    </VStack>
  );
}
